// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import i18n from '@/lang/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/icons'
import Vue from 'vue'
import App from './App'
import router from './router'
import Chat from 'vue-beautiful-chat'
// import './common/element.js'

Vue.config.productionTip = false

Vue.use(ElementUI,{
  i18n: (key, value) => i18n.t(key, value)
})

Vue.use(Chat)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: {App},
  template: '<App/>'
})
